"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerField = void 0;
var _datePickers = require("@ori-ui/date-pickers");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _DateAdapter = _interopRequireDefault(require("@ori-ui/mui/DateAdapter"));
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _components = require("../components");
var _utils = require("../utils");
var _SharedStyledComponents = require("./SharedStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const StyledInfoBox = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  fontSize: '12px',
  marginTop: theme.spacing(2),
  color: theme.palette.grey.A400
}));
const StyledInfoCircle = (0, _mui.styled)(_icons.InfoCircle)(({
  theme
}) => ({
  fontSize: '30px',
  marginRight: theme.spacing(2)
}));
const DatePickerField = props => {
  const {
    name,
    label,
    infoText,
    isEditable,
    isAvailable,
    displayOrder,
    defaultDate,
    isMandatory,
    variant,
    maxDate,
    minDate,
    customErrors,
    autoFocus,
    customMaxWidth
  } = props;
  const {
    getTestIdProps,
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    culture
  } = (0, _culture.useCulture)();
  const culturePattern = culture?.calendarFormat?.patterns?.shortDatePattern ?? '';
  const dateFormat = (0, _utils.generateDateFormat)(culturePattern);
  const submitError = customErrors?.find(error => error.fieldName?.toLowerCase() === name.toLowerCase());
  const errorMessage = submitError ? (0, _utils.getErrorLocalizationByCode)(submitError?.errorCode, name) : undefined;

  // we need start tabindex from 1 but displayOrder starts from 0
  const correctTabIndex = typeof displayOrder === 'number' ? displayOrder + 1 : displayOrder;
  const renderInputProps = fieldState => ({
    fullWidth: true,
    variant: variant ?? 'outlined',
    disabled: !isEditable,
    required: isMandatory,
    error: !!fieldState.error,
    inputProps: {
      autoFocus,
      tabIndex: correctTabIndex,
      'data-testid': getTestId(`${name}-date-field`),
      maxLength: 10 // hardcoded for HR where we hawe this strange form dd.mm.yyyy. and for picker is possible this value 09.09.2000.0
    },
    helperText: fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
      sx: {
        marginLeft: 0,
        marginTop: 0
      },
      error: true,
      children: fieldState.error.message
    }) : null
  });
  const renderField = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      margin: "0 auto 20px",
      maxWidth: customMaxWidth ?? 500,
      textAlign: "left",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        defaultValue: defaultDate ?? null,
        render: ({
          field,
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_datePickers.LocalizationProvider, {
          dateAdapter: _DateAdapter.default,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledFormControl, {
            fullWidth: true,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_datePickers.DesktopDatePicker, {
              disableOpenPicker: true,
              open: false,
              format: dateFormat,
              label: label,
              minDate: minDate,
              maxDate: maxDate,
              disabled: !isEditable,
              ...field,
              slotProps: {
                textField: {
                  ...renderInputProps(fieldState),
                  onBlur: field.onBlur
                }
              }
            }), errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ErrorMessage, {
              errorMessage: errorMessage,
              maxDate: maxDate
            }) : null]
          })
        })
      }), infoText ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledInfoBox, {
        ...getTestIdProps(`${name}-date-field-info-text`),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInfoCircle, {}), infoText]
      }) : null]
    })
  });
  const fieldComponent = isAvailable && renderField();
  return fieldComponent;
};
exports.DatePickerField = DatePickerField;
